import { Action } from '../../../redux/redux.types';
import {
  flowVersionsList,
  FlowVersionsListState,
} from './flow-versions-list.reducer';
import { flowsList, FlowsListState } from './flows-list.reducer';
import { flowsUi, FlowsUiState } from './flows-ui.reducer';

export interface FlowsState {
  flowsList: FlowsListState;
  flowVersionsList: FlowVersionsListState;
  flowsUi: FlowsUiState;
}

export const flows = (
  state: Partial<FlowsState> = {},
  action: Action,
): FlowsState => {
  const uiState = flowsUi(state.flowsUi, action);

  return {
    flowsList: flowsList(state.flowsList, action),
    flowVersionsList: flowVersionsList(
      state.flowVersionsList,
      action,
      uiState.selectedFlowId,
    ),
    flowsUi: uiState,
  };
};
